import React, { Fragment, useState } from "react"
import { useDispatch } from "react-redux"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import loader from "./assets/loader.gif"
import Error from "./frontend/components/blank/Error"
import { ContactUs } from "./frontend/components/ContactUs/ContactUs"
import CancelledOrderDetails from "./frontend/components/MyAccount/Order/CancelledOrderDetails"
import ReceivedOrderDetails from "./frontend/components/MyAccount/Order/ReceiveOrdersDetails"
import PopupCampaign from "./frontend/components/PopupCampaign/PopupCampaign"
import QuickBuy from "./frontend/components/QuickBuy/QuickBuy"
// import Footer from "./frontend/partials/Footer/footer"
import Test from "./Test"

const VendorDetails = React.lazy(() => import("./frontend/components/VendorDetails/VendorDetails"))
const BrandDetails = React.lazy(() => import("./frontend/components/BrandDetails/BrandDetails"))
const BrandList = React.lazy(() => import("./frontend/components/BrandList/BrandList"))
const VendorLogin = React.lazy(() => import("./frontend/components/vendorLogin/VendorLogin"))
const VendorRegistration = React.lazy(() => import("./frontend/components/VendorRegistration/VendorRegistration"))
const StoreList = React.lazy(() => import("./frontend/components/StoreList/StoreList"))
const Voucher = React.lazy(() => import("./frontend/components/Voucher/Voucher"))
const Cart = React.lazy(() => import("./frontend/components/Cart/Cart"))
const Checkout = React.lazy(() => import("./frontend/components/Checkout/Checkout"))
const Collection = React.lazy(() => import("./frontend/components/Collection/Collection"))
const CheckMail = React.lazy(() => import("./frontend/components/ForgetPassword/CheckMail"))
const EmailSuccess = React.lazy(() => import("./frontend/components/ForgetPassword/EmailSuccess"))
const ForgetPassword = React.lazy(() => import("./frontend/components/ForgetPassword/ForgetPassword"))
const ResetPassword = React.lazy(() => import("./frontend/components/ForgetPassword/ResetPassword"))
const Login = React.lazy(() => import("./frontend/components/Login/Login"))
const OrderPlacement = React.lazy(() => import("./frontend/components/OrderPlacement/OrderPlacement"))
const WishList = React.lazy(() => import("./frontend/components/WishList/WishList"))
const Signup = React.lazy(() => import("./frontend/components/Signup/Signup"))
const ProductDetails = React.lazy(() => import("./frontend/components/ProductDetails/ProductDetails"))
const MyAccount = React.lazy(() => import("./frontend/components/MyAccount/MyAccount"))
const Otp = React.lazy(() => import("./frontend/components/Otp/Otp"))
const Footer = React.lazy(() => import("./frontend/partials/footer/Footer"))
const Header = React.lazy(() => import("./frontend/partials/header/Header"))
const Home = React.lazy(() => import("./frontend/components/Home/Home"))
const CategoryProducts = React.lazy(() => import("./frontend/containers/Category/CategoryProducts"))
const SearchProducts = React.lazy(() => import("./frontend/components/SearchProducts/SearchProducts"))
const OrderDetails = React.lazy(() => import("./frontend/components/MyAccount/Order/OnGoingOrderDetails"))
const Notification = React.lazy(() => import("./frontend/components/MyAccount/Notification/Notification"))
const AllReceivedOrder = React.lazy(() => import("./frontend/components/MyAccount/Order/AllReceivedOrder"))
const ReceivedOrder = React.lazy(() => import("./frontend/components/MyAccount/Order/ReceiveOrdersDetails"))
const AllOrderItem = React.lazy(() => import("./frontend/components/MyAccount/Order/AllOrderItem"))
const MobileCategories = React.lazy(() => import("./frontend/containers/Category/MobileCategories"))

/* user info */

export default function AllRoutes() {
	
	const dispatch = useDispatch()

	// const [opentop, setOpenTop] = useState(false)

	// const handleTopProduct = () => {
	// 	setOpenTop(true)
	// 	// console.log("test")
	// }

	const [openTab, setOpenTab] = useState(1)
 
	return (
		<BrowserRouter>
			<>
			 
				<Header  setOpenTab={setOpenTab} openTab={openTab}/>
				<div className='relative h-full '>
					<div className='relative z-30 bg-white py-4 px-0 sm:px-4'>
						<Routes>
							<Route
								exact
								path='/'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Home />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/signup'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Signup />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/login'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Login />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/forget-password'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<ForgetPassword />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/check-mail'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<CheckMail />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/email-success'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain  ' src={loader} alt='loader' />
											</div>
										}
									>
										<EmailSuccess />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/otp'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Otp />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/reset-password'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<ResetPassword />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/product/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<ProductDetails />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/cart'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Cart />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/checkout'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Checkout />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/quickbuy'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<QuickBuy />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/order-placement'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<OrderPlacement />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/collection'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Collection />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/wishlist'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<WishList />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/voucher'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Voucher />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/store-list'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<StoreList />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/vendor/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<VendorDetails />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/brand'
								element={
									<React.Suspense
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<BrandList />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/brand/:id'
								element={
									<React.Suspense
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<BrandDetails />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/vendor-login'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<VendorLogin />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/contact-us'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<ContactUs />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/vendor-registration'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<VendorRegistration />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/my-account'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										  
										<MyAccount setOpenTab={setOpenTab} openTab={openTab}    />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/category/products/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<CategoryProducts />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/category/search/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<SearchProducts />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/my-account/notification'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Notification />
									</React.Suspense>
								}
							/>
							{/* <Route
								exact
								path='/my-account/chat'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Chat />
									</React.Suspense>
								}
							/> */}

							{/* <Route
								exact
								path='/my-account/order'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Order />
									</React.Suspense>
								}
							/> */}
							<Route
								exact
								path='/my-account/ongoing-order/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<OrderDetails />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/my-account/receive-order/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<ReceivedOrderDetails />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/my-account/cancel-order/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<CancelledOrderDetails />
									</React.Suspense>
								}
							/>

							{/* <Route
								exact
								path='/my-account/review'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Review />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/my-account/refund'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Refunds />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/my-account/return'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Return />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/my-account/subscription'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<Subscription />
									</React.Suspense>
								}
							/> */}

							<Route
								exact
								path='/my-account/all-order'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<AllOrderItem />
									</React.Suspense>
								}
							/>
							<Route
								exact
								path='/my-account/received-order'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<AllReceivedOrder />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/my-account/received-details/:id'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<ReceivedOrder />
									</React.Suspense>
								}
							/>

							<Route
								exact
								path='/categories'
								element={
									<React.Suspense
										// fallback='Loading...'
										fallback={
											<div className='flex justify-center items-center h-full w-full'>
												<img className='h-72 w-auto object-contain ' src={loader} alt='loader' />
											</div>
										}
									>
										<MobileCategories />
									</React.Suspense>
								}
							/>

							<Route exact path='/*' element={<Error />} />
							<Route exact path='/test' element={<Test />} />
						</Routes>
					</div>
					{/* <div className='fixed z-50  top-[50%] right-0 group'>
						<div
							className='bg-[#2C8DFF] h-auto w-max p-3 rounded-md transition ease-in-out duration-200 translate-x-32 group-hover:translate-x-0  flex gap-x-4
						 justify-center items-center text-white font-semibold cursor-pointer '
							onClick={() => handleTopProduct()}
						>
							<BadgeCheckIcon className='h-6 w-6' />
							<p>Top purchase</p>
						</div>
					</div> */}
				</div>
				<Footer />
			</>

			<PopupCampaign />

			{/* Top Purchase

			<Transition.Root show={opentop} as={Fragment}>
				<Dialog as='div' className='relative z-50' onClose={()=>setOpenTop(false)}>
					<Transition.Child as={Fragment} enter='ease-out duration-300' enterFrom='opacity-0' enterTo='opacity-100' leave='ease-in duration-200' leaveFrom='opacity-100' leaveTo='opacity-0'>
						<div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
					</Transition.Child>

					<div className='fixed inset-0 z-10 overflow-y-auto'>
						<div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
							<Transition.Child as={Fragment} enter='ease-out duration-300' enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95' enterTo='opacity-100 translate-y-0 sm:scale-100' leave='ease-in duration-200' leaveFrom='opacity-100 translate-y-0 sm:scale-100' leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
								<Dialog.Panel className='relative transform overflow-hidden rounded-lg  px-4 pt-5 pb-4 text-left  transition-all sm:my-8 sm:w-full sm:max-w-5xl sm:p-8'>
									<div className='absolute top-0 right-0 hidden pt-3 pr-3 sm:block'>
										<button type='button' className='rounded-md  text-red-300 hover:text-red-500 focus:outline-none' onClick={()=>setOpenTop(false)}>
											<span className='sr-only'>Close</span>
											<XIcon className='h-6 w-6' aria-hidden='true' />
										</button>
									</div>

									<div className='relative h-full w-full'>
										<figure>
											<img className='h-auto sm:h-96 w-full object-contain sm:object-cover rounded-lg' src='/images/promotional.png' alt='promotion' />
										</figure>
									</div>
								</Dialog.Panel>
							</Transition.Child>
						</div>
					</div>
				</Dialog>
			</Transition.Root> */}
		</BrowserRouter>
	)
}
